import pkg from '../../package.json';

const SS_KEY = 'spark.reloadedForVersion';
let serverVersion = null;
const listeners = new Set();

/** Порівняння semver: >0, якщо a новіша за b. */
export function compareVersions(a, b) {
  const pa = String(a).split('.').map((n) => parseInt(n, 10) || 0);
  const pb = String(b).split('.').map((n) => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d;
  }
  return 0;
}

export const getOutdatedVersion = () => serverVersion;
export const subscribeOutdated = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

function readReloaded() { try { return sessionStorage.getItem(SS_KEY); } catch { return null; } }
function markReloaded(v) { try { sessionStorage.setItem(SS_KEY, v); } catch { /* ignore */ } }

/**
 * Перезавантажити на нову версію — не частіше разу на версію (захист від циклу, якщо index.html
 * ще віддається зі старого кешу). Повертає true, якщо перезавантаження запущено.
 */
export function reloadForNewVersion() {
  if (!serverVersion || readReloaded() === serverVersion) return false;
  markReloaded(serverVersion);
  window.location.reload();
  return true;
}

export function noteServerVersion(v) {
  if (!v || compareVersions(v, pkg.version) <= 0) return;
  if (serverVersion && compareVersions(serverVersion, v) >= 0) return;
  serverVersion = v;
  listeners.forEach((fn) => fn(v));
  // вкладка у фоні — оновлюємо одразу, користувач нічого не втратить
  if (document.visibilityState === 'hidden') reloadForNewVersion();
}

/** Обгортка над fetch: читає X-App-Version з відповідей бекенду. Викликати один раз на старті. */
export function installAppVersionGuard() {
  if (window.__sparkVersionGuard) return;
  window.__sparkVersionGuard = true;
  const orig = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await orig(...args);
    try { noteServerVersion(res.headers.get('x-app-version')); } catch { /* ignore */ }
    return res;
  };
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden' && serverVersion) reloadForNewVersion();
  });
}
